<template>
  <modal
    v-slot="{ data }"
    name="order-item-rating-modal"
    modal-style="compact"
  >
    <order-item-rating
      :item="data.item"
      :item-rating="data.itemRating"
      :order="data.order"
    />
  </modal>
</template>


<script>
  import OrderItemRating from './order-item-rating/index.vue';


  export default {
    name: 'OrderItemRatingModal',

    components: {
      OrderItemRating
    }
  };
</script>
